<template>
    <div class="web">
		<!-- 解决手机端强制横屏后，一进入页面，本页在最底部的BUG -->
		<div id="top"></div>
        <!-- 顶部 -->
        <p class="web-title back">WEB网页</p>
        <div class="header-container">
            <div class="web-title-background">
              <div class="masterpiece-title">作品集</div>
                <p class="web-title front">WEB网页</p>
            </div>

            <div class="four-images-container">
                <div class="main-image-container">
                    <img v-lazy="require(`@/assets/web_img_1.png`)" class="main-image">
                </div>
                <div class="four-images-inner">
                    <div  class="small-image" v-for="(image, index) in carouselImages" :key="index" v-if="index < 4">
						<img v-lazy="require(`@/assets/itemImgs/${image.srcCut}.jpg`)"
						@click="scroll(index, image)">
					</div>
                </div>
            </div>
        </div>

        <!-- 主体内容 -->
        <div class="main-content">
            <div class="content-container">
                <!-- 左侧栏 -->
                <div class="sidebar">
                    <div class="sidebar-title">
                        <div class="title-wrapper">
                            <p class="title-char">预</p>
                            <p class="title-english">PREVIEW</p>
                        </div>
                        <p class="title-char">览</p>
                    </div>
                    <div class="sidebar-content">
                        <p class="content-text">
                            {{ curWeb.name }}
                        </p>
                        <div class="content-date">
                            <div v-if="curWeb.startTime">
								<p class="date">{{ curWeb.startTime }}&nbsp;</p>
								<p class="separator" v-if="curWeb.endTime">|</p>
								<p class="duration">{{ curWeb.endTime }}</p>
							</div>
                        </div>
						<!-- <div class="back-btn" @click="$router.push('/index')">
							返回主页
						</div> -->
                    </div>
                </div>

                <!-- 右侧内容 -->
                <div class="content-right">
                    <div class="project-image-container">
                        <div class="iframe_wrap" :class="{'app_wrap':curWeb.isApp}">
                            <div class="iframe_inner">
                                <div class="iframe_bg">
                                    <div class="cannot_img" v-if="(curWeb.isOnline || curWeb.isOnlyPic) && !curWeb.isApp">
                                        <!-- <div class="cannot_word">
                                            <h3>使用https协议的网站无法嵌入http资源，该网站无法在本站预览，请点击右下方按钮查看在线网站。</h3>
                                        </div> -->
                                        <img v-lazy="require(`@/assets/itemImgs/${curWeb.srcCut}.jpg`)">
                                    </div>
                                    <iframe id="iframe" name="mainIframe" @load="iframeLoad" :src="curWeb.src" frameborder="0" scrolling="auto" v-else></iframe>
                                </div>
                            </div>
                        </div>
                        <div class="project-image-shadow"></div>
                    </div>

                    <div class="project-description">
						<p class="description-text" v-if="curWeb.isOnline && !curWeb.isApp">
							https协议的网站无法嵌入http资源，该网站无法预览，只能查看图片。
						</p>
						<p class="description-text" v-if="curWeb.isOnlyPic">已下线，暂无离线版本，只能查看图片效果</p>
						<div class="preview-btn" @click="goWeb()" v-else>
							<b v-if="!curWeb.isOnline && !curWeb.isScan && !curWeb.isApp">已下线查看离线版本（电脑端点击进入大屏预览效果更佳）</b>
							<b v-if="curWeb.isOnline && !curWeb.isScan">查看线上网站（电脑端点击进入大屏预览效果更佳）</b>
							<b v-if="curWeb.isScan">扫码查看线上版本</b>
							<b v-if="curWeb.isApp && !curWeb.isScan">手机查看效果更佳</b>
						</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 轮播图 -->
        <div class="carousel-container">
			<div class="carousel-nav">
				<div class="nav-buttons">
					<img :src="require(`@/assets/arrow.png`)" class="nav-arrow" @click="slideRight" :class="{ 'disabled': isAtStart }">
					<img :src="require(`@/assets/arrow.png`)" class="nav-arrow right" @click="slideLeft" :class="{ 'disabled': isAtEnd }">
				</div>
			</div>
			<div class="carousel-images">
				<div class="carousel-track"
					:style="{ transform: `translateX(${offsetX + dragOffset}px)` }"
					@mousedown="startDrag"
					@touchstart="startDrag"
					@mousemove="onDrag"
					@touchmove="onDrag"
					@mouseup="endDrag"
					@mouseleave="endDrag"
					@touchend="endDrag">
					<div class="carousel-image-block"
						v-for="(image, index) in carouselImages"
						:key="index"
						:class="{ 'active': activeCarouselIndex === index }"
						@click="setActiveCarouselIndex(index, image)">
						<img v-lazy="require(`@/assets/itemImgs/${image.srcCut}.jpg`)" class="carousel-image">
					</div>
				</div>
			</div>
		</div>
		<div class="fixed-btn top" @click="toTop()" v-if="!isMobile">
			<img :src="require(`@/assets/arrow.png`)">
		</div>
		<div class="fixed-btn back" @click="$router.push('/index')">
			<img :src="require(`@/assets/arrow.png`)">
		</div>
    </div>
</template>

<script>
import db from "@/common/js/db";

export default {
    name: 'web',
    data() {
        return {
            curWeb: {},
            webs: db().webs,
            // 轮播图相关数据
            carouselImages: [],
            activeCarouselIndex: 0,
            currentPosition: 0,
            itemWidth: 460, // 图片宽度 + 边距
            visibleItems: 3, // 可见图片数量
            isDragging: false,
            startX: 0,
            dragOffset: 0,
            lastDragOffset: 0,
            velocity: 0,
            lastTime: 0,
            animationId: null,
			curWebIndex:0,
			curWeb:{},
			iframePageNum: 0
        }
    },
    computed: {
        offsetX() {
            return -this.currentPosition * this.itemWidth;
        },
        isAtStart() {
            return this.currentPosition <= 0;
        },
        isAtEnd() {
            return this.currentPosition >= this.carouselImages.length - this.visibleItems;
        },
		// 是否是手机端
		isMobile() {
			return window.innerWidth < 768; // 通常768px是移动和桌面的分界点
		},
		// 是否是手机端
		isSmPc() {
			return window.innerWidth < 1440 && window.innerWidth > 768; // 小分辨率PC端
		}
    },
    created() {
		this.visibleItems = this.isSmPc ? 2 : 3 // 可见图片数量:pc3，小pc2
        this.itemWidth = this.isMobile ? 170 : 460, // 图片宽度 + 边距
        this.curWeb = this.webs[0] || {}; // 默认显示第一个项目
		this.carouselImages = this.webs
		this.curWebIndex = this.$route.params.itemIndex ? this.$route.params.itemIndex : 0
		this.curWeb = this.webs[this.curWebIndex]
    },
	mounted(){
		this.mobileToTop()
	},
	watch:{
	  curWebIndex(n,o){
	    this.curWeb = this.webs[this.curWebIndex]
	  }
	},
    methods: {
		// 解决手机端强制横屏后，一进入页面，本页在最底部的BUG
		mobileToTop(){
			if(!this.isMobile){ return }
			this.$nextTick(()=>{
				this.$nextTick(() => {
					// 滚动条固定到定位元素位置
					const tabElement = document.getElementById('top');
					if (tabElement) {
					  tabElement.scrollIntoView({
						behavior: 'auto',
						inline: 'nearest'
					  });
					}
				});
			})
		},
		toTop(){
			// 默认页面水平滚动到右边（适配手机端）
			window.scrollTo({
			  top: 0,
			  behavior: 'smooth' // 可选，平滑滚动
			});
		},
		iframeLoad(){
			this.iframePageNum ++
		},
		// 自定义返回方法
        customGoBack() {
          if (this.iframePageNum > 0) {
            // 如果 iframe 有历史记录，先返回 iframe 的历史
            const iframe = document.getElementById('iframe');
            for(let i = 0; i < this.iframePageNum - 1; i++){
              iframe.contentWindow.history.back();
            }

            this.iframePageNum = 0
          } else {
            // 否则返回 Vue 路由的历史
            this.$router.go(-1);
          }
        },
        goWeb(){
          window.open(this.curWeb.src)
        },
        // 轮播图相关方法
        setActiveCarouselIndex(index, image) {
            this.curWebIndex = index;
          	this.activeCarouselIndex = index;
          	if (index > this.currentPosition + this.visibleItems - 1) {
          		this.currentPosition = index - this.visibleItems + 1;
          	} else if (index < this.currentPosition) {
          		this.currentPosition = index;
          	}
        },
        slideLeft() {
            if (!this.isAtEnd) {
                this.currentPosition += this.visibleItems;
                if (this.currentPosition > this.carouselImages.length - this.visibleItems) {
                    this.currentPosition = this.carouselImages.length - this.visibleItems;
                }
            }
        },
        slideRight() {
            if (!this.isAtStart) {
                this.currentPosition -= this.visibleItems;
                if (this.currentPosition < 0) {
                    this.currentPosition = 0;
                }
            }
        },
        startDrag(e) {
            this.isDragging = true;
			let key = this.isMobile ? 'clientY' : 'clientX'
			this.startX = e[key] || e.touches[0][key];
            this.lastDragOffset = 0;
            this.velocity = 0;
            this.lastTime = Date.now();
            cancelAnimationFrame(this.animationId);
        },
        onDrag(e) {
            if (!this.isDragging) return;
			
			let key = this.isMobile ? 'clientY' : 'clientX'
            const x = e[key] || e.touches[0][key];
            const now = Date.now();
            const deltaTime = now - this.lastTime;

            this.dragOffset = x - this.startX;

            if (deltaTime > 0) {
                this.velocity = (this.dragOffset - this.lastDragOffset) / deltaTime;
                this.lastDragOffset = this.dragOffset;
                this.lastTime = now;
            }

            e.preventDefault();
        },
        endDrag() {
            if (!this.isDragging) return;
            this.isDragging = false;

            // 计算惯性滑动距离
            const momentumDistance = this.velocity * 50;
            const totalOffset = this.dragOffset + momentumDistance;

            // 计算应该移动的图片数量
            const itemDelta = Math.round(totalOffset / this.itemWidth);

            // 计算新位置
            let newPosition = this.currentPosition - itemDelta;
            newPosition = Math.max(0, Math.min(newPosition, this.carouselImages.length - this.visibleItems));

            this.currentPosition = newPosition;
            this.dragOffset = 0;
            this.velocity = 0;
            this.lastDragOffset = 0;
        },
		scroll(index, image){
			this.setActiveCarouselIndex(index, image)
			window.scrollTo({
			  top: 100,
			  behavior: 'smooth' // 平滑滚动
			});
		}
    }
}
</script>

<style lang="less" scoped>
    .web {
        width: 100%;
        background: #fbca7e;
        overflow: hidden;
    }

    /* 顶部区域样式 */
    .header-container {
        width: calc(100% - 90px);
        margin: 0 auto;
        color: #3f062f;
        position: relative;
    }

    .web-title-background {
        position: relative;
        width: 100%;
        height: 265px;
    }
    .web-title {
        width: calc(100% - 5vw);
        text-align: center;
        font-size: 160px;
        letter-spacing: 65.69px;
        font-weight: 700;
        color: #FDEBD8;
        padding-left: 5vw;

        &.back {
            background: #fff;
            margin-top: -100px;
            line-height: 200px;
        }

        &.front {
          opacity: 0.2;
          margin-top: -30px;
          transform: rotateX(180deg);
          line-height: 260px;
        }
    }

    .masterpiece-title {
        position: absolute;
        width: 100%;
        text-align: center;
        height: 91px;
        line-height: 91px;
        font-size: 76px;
        top: 90px;
        font-weight: 700;
        z-index: 1;
    }

    .main-image-container {
        width: 76%;
        z-index: 1;
        top: -13.5vw;
        position: absolute;
        left: 14%;
		height: 25vw;
		overflow: hidden;

        img {
            width: 100%;
        }
    }

    .four-images-container {
        background: #ffffff;
        padding: 15vw 0 100px;
        width: 100%;
        margin-top: 12vw;
        position: relative;
    }

    .four-images-inner {
        width: 75%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }

    .small-image {
        width: 22%;
		height: 7.2vw;
        border-radius: 20px;
		cursor: pointer;
		overflow: hidden;
		box-shadow: 0 3px 7px 7px rgba(193, 143, 44, 0.1);
		transition: all 0.3s;
		
		img{
			width: 100%;
			vertical-align: bottom;
		}
		
		&:active,&:hover{
			box-shadow: none;
		}
    }

    /* 主体内容样式 */
    .main-content {
        width: 100%;
        color: #ffffff;
    }

    .content-container {
        display: flex;
        width: 100%;
        margin: 0 auto;
    }

    .sidebar {
        background: #774047;
        padding: 207px 45px 37vw;
        width: 220px;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 42px;
        margin-left: 45px;
    }

    .sidebar-title {
        display: flex;
        align-items: flex-start;
        font-weight: 700;

		&>.title-char{
			margin-top: 40px;
		}
    }

    .title-wrapper {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .title-char {
        margin: 0 0 0 23px;
        min-width: 73px;
        line-height: 88px;
        font-size: 73px;
    }

    .title-english {
        margin: 5px 0 0;
        min-width: 91px;
        line-height: 27px;
        font-size: 22px;
    }

    .sidebar-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 44px;
        width: 170px;
		height: 170px;
    }

    .content-text {
        min-width: 96px;
        text-align: center;
        line-height: 29px;
        font-size: 24px;
    }

    .content-date {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 56px;
        width: 75px;
        line-height: 24px;
        font-size: 20px;
		text-align: center;
    }

    .date {
        min-width: 75px;
    }

    .separator {
        margin: 12px 0 0;
        min-width: 7px;
    }

    .duration {
        margin: 12px 0 0;
        min-width: 40px;
    }

    .content-right {
        flex: 1;
        position: relative;
        z-index: 0;
    }

    .project-image-container {
        width: 70%;
        position: relative;
        margin: 130px auto 0;
    }

    /* iframe相关样式 */
    .iframe_wrap {
        width: 100%;
        height: 400px;
		overflow: hidden;
        position: relative;
        z-index: 1;
        text-align: center;
    }

    .iframe_inner {
        background: #000;
        padding: 13px;
        border-radius: 30px 30px 0 0;
        height: 100%;
    }

    .iframe_bg {
        background: #f5f5f5;
        height: 100%;
        overflow: hidden;
        border-radius: 20px 20px 0 0;

        iframe {
            height: 100%;
            width: 101.3%;
        }
    }

    .app_wrap {
        height: 380px;

        .iframe_bg {
            height: 380px;
        }

        iframe {
            width: 270px !important;
            height: 380px !important;
        }
    }

    .cannot_img {
        position: relative;
        height: 100%;
		overflow: auto;

        img {
            width: 100%;
            // height: 100%;
            // filter: blur(10px);
        }
    }

    .cannot_word {
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 23% 0;
        background: rgba(0,0,0,.5);
        text-align: center;
        font-weight: 700;
        color: #96e4e9;
        line-height: 40px;
        z-index: 2;
        transition: all .5s;
    }

    .project-image-shadow {
        border-radius: 9px;
        background: #000;
        width: 104%;
        height: 18px;
        position: absolute;
        bottom: -10px;
        z-index: 1;
        left: -2%;
    }

    .project-description {
        background: #f6ae3f;
        padding: 60px 100px 80px;
        margin-top: -10px;
        font-size: 23px;
		min-height: 200px;
		text-align: center;
    }

    .description-title {
        font-weight: bold;
    }

    .description-text {
        height: 60px;
        line-height: 40px;
    }

    /* 轮播图样式 */
    .carousel-container {
        width: 100%;
        overflow: hidden;
        background: #774047;
        display: flex;
        margin-bottom: 105px;
        margin-top: -380px;
        position: relative;
        z-index: 1;
    }

    .carousel-nav {
        background: #3f062f;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 110px 93px 105px;
        margin-left: 45px;
        width: 220px;
    }

    .nav-buttons {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .nav-arrow {
        width: 42px;
        height: 54px;
        margin: 0 10px;
        cursor: pointer;
        transition: opacity 0.3s ease;

        &:hover:not(.disabled) {
            opacity: 0.7;
        }

        &.disabled {
            opacity: 0.3;
            cursor: not-allowed;
        }

        &.right {
            transform: rotate(180deg);
        }
    }

    .carousel-images {
        display: flex;
        align-items: flex-start;
        padding: 31px 0 0 0;
        flex-grow: 1;
        overflow: hidden;
        position: relative;
    }

    .carousel-track {
        display: flex;
        transition: transform 0.3s ease-out;
        will-change: transform;
        cursor: grab;
        padding: 0 30px;

        &.grabbing {
            cursor: grabbing;
            transition: none;
        }
    }

    .carousel-image-block {
		width: 400px;
		height: 200px;
		overflow: hidden;
		margin-left: 60px;
		border-radius: 20px;
		display: flex;
		align-items: center;
		flex-shrink: 0;
		transition: all 0.3s ease;
		cursor: grab;
		background: rgba(255, 255, 255, 0.1);
		justify-content: center;

		img {
			height: 100%;
			vertical-align: bottom;
			transition: all 0.3s ease;
			pointer-events: none; /* 防止图片干扰点击事件 */
			border-radius: 15px; /* 稍微小于父元素的圆角 */
			user-select: none;
		}

		&.active {
			transform: scale(1.1);
			box-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
			border: 2px solid #ffffff;
		}

		&:hover:not(.active) {
			img {
				opacity: 0.8;
			}
		}
	}
	.preview-btn{
		background: #fff;
		border-radius: 30px;
		padding: 15px 30px;
		font-size: 20px;
		color: #f6ae3f;
		// width: 40%;
		display: inline-block;
		text-align: center;
		margin: 0 auto;
		cursor: pointer;
		transition: all 0.3s;

		&:hover, &:active{
			transform: scale(0.9, 0.9);
		}

		&.active{
			background: none;
			border: 1px solid #fff;
			color: #fff;
			margin-top: 30px;
			opacity: 0.5;
		}
	}
	.back-btn{
		margin-top: 30px;
	}
	.fixed-btn{
		position: fixed;
		right: 10px;
		
		&.top{
			bottom: 55px;
			background: #a36c6f;
			
			img{
				transform: rotate(90deg);
			}
		}
		
		&.back{
			bottom: 10px;
			background: #3f062f;
		}
	}
	@media screen and (max-width: 1440px){
		.iframe_wrap{
			height: 380px;
		}
		.project-image-container{
			margin: 100px auto 0;
		}
		.sidebar{
			padding: 150px 45px 37vw;
		}
		.description-text{
			height: 40px;
			line-height: 25px;
			margin-top: -10px;
		}
	}
	@media screen and (max-width: 1367px){
		.iframe_wrap{
			height: 350px;
		}
		.project-image-container{
			margin: 100px auto 0;
		}
		.sidebar{
			padding: 150px 45px 37vw;
		}
		.description-text{
			height: 40px;
			line-height: 25px;
			margin-top: -10px;
		}
	}
    /* 手机端强制横屏 */
    @media screen and (orientation:portrait) {
        .web{
            // 强制横屏
            width: 100vh;
            overflow-y: hidden;
            transform-origin: 0 0;
            transform: rotateZ(90deg) translateY(-100%);
        }
		.header-container{
			width: calc(100% - 40px);
		}
		.web-title{
			font-size: 90px;
			letter-spacing: 20px;

			&.front{
				line-height: 150px;
			}
			&.back{
				margin-top: -40px;
				line-height: 100px;
			}
		}
		.masterpiece-title{
			font-size: 40px;
			top: 30px;
			font-weight: bold;
		}
		.web-title-background{
			height: 180px;
		}
		.main-image-container{
			top: -25vw;
			height: 30vh;
		}
		.four-images-container{
			padding: 30vw 0 50px;
		}
		.small-image{
			border-radius: 10px;
			height: 7.2vh;
		}
		.sidebar{
			margin-left: 20px;
			width: 70px;
			font-size: 20px;
			padding: 70px 45px 45vw;
		}
		.title-char{
			font-size: 40px;
			min-width: 40px;
			line-height: 50px;
		}
		.title-english{
			font-size: 15px;
			min-width: 40px;
		}
		.sidebar-title > .title-char{
			margin-left: 5px;
		}
		.content-text{
			font-size: 20px;
		}
		.content-date{
			font-size: 16px;
			margin-top: 20px;
			opacity: 0.7;
		}
		.sidebar-content{
			margin-top: 30px;
		}
		.project-image-container{
			margin-top: 50px;
		}
		.iframe_inner{
			padding: 8px;
		}
		.iframe_wrap{
			height: 220px;
		}
		.project-image-shadow{
			height: 10px;
			bottom: -2px;
		}
		.carousel-container{
			margin-top: -160px;
			margin-bottom: 30px;
		}
		.carousel-nav{
			margin-left: 20px;
			width: 70px;
			padding: 30px 45px 30px;
		}
		.project-description{
			padding: 30px 20px 40px;
			font-size: 16px;
			min-height: 100px;
		}
		.description-text{
			height: 30px;
			line-height: 25px;
		}
		.preview-btn{
			font-size: 14px;
			padding: 8px 25px;
		}
		.carousel-images{
			padding: 15px 0;
		}
		.carousel-image-block{
			width: 150px;
			height: 75px;
			margin-left: 20px;
			border-radius: 10px;

			img{
				border-radius: 10px;
			}
		}
		.nav-arrow{
			width: 30px;
			height: 40px;
		}
		.preview-btn{
			&.active{
				margin-top: 10px;
			}
		}
		.separator, .duration{
			margin-top: 0;
		}
    }
	// 适配手机端非全屏浏览器(页面高度更短)
	@media screen and (min-height: 600px) and (max-height: 680px) and (max-width: 768px) {
		.project-description{
			font-size: 13px;
		}
		.preview-btn{
			font-size: 13px;
		}
		.iframe_wrap{
			height: 175px;
		}
		.project-description{
			min-height: 60px;
		}
		.sidebar{
			padding-bottom: 35vw;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/web/web.vue